import Layout from "@/components/layout/Layout";
import { Check } from "lucide-react";
import SEO from "@/components/SEO";

const benefits = [
  "Injection-molded polycarbonate — far more durable than saw-cut acrylic",
  "UV-resistant eco-friendly inks for long-lasting, vibrant color",
  "Rack into Pronto Track instantly — no tools or adhesives",
  "Change messages from the ground with the telescoping Change Arm",
  "Available in Modern, ADM, and Condensed styles to match any sign",
  "Multiple sizes from 3″ to 10″ for every application",
];

export default function About() {
  return (
    <Layout>
      <SEO
        title="About Pronto Letters"
        description="Learn how Gemini Pronto™ changeable letters work — injection-molded polycarbonate, UV-resistant inks, aluminum track, and ground-level change arms for easy message changes."
        canonical="/about"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: "About Pronto Letters by Gemini",
          description: "Gemini Pronto™ changeable letter sets — injection-molded polycarbonate, UV-resistant inks, and the complete Pronto Track system.",
          url: "https://pronto-letters.com/about",
        }}
      />
      <div className="container max-w-3xl py-16">
        <h1 className="font-display text-4xl font-bold">About Pronto Letters</h1>
        <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
          Gemini Pronto™ changeable letters are the industry standard for durable, attractive changeable copy signage. Unlike traditional saw-cut acrylic letters, Pronto letters are injection-molded from tough polycarbonate and printed with UV-resistant eco-friendly inks — delivering superior longevity and visual impact.
        </p>

        <h2 className="mt-12 font-display text-2xl font-semibold">How the System Works</h2>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          The Pronto system is elegantly simple: aluminum <strong>Pronto Track</strong> is mounted to your sign panel using rivets or screws. Letters rack directly into the track with a satisfying snap. Need to change your message? Use the telescoping <strong>Change Arm</strong> to swap letters from the ground — no ladders, no tools, no hassle.
        </p>

        <h2 className="mt-12 font-display text-2xl font-semibold">Why Choose Pronto?</h2>
        <ul className="mt-6 space-y-3">
          {benefits.map((b) => (
            <li key={b} className="flex items-start gap-3 text-muted-foreground">
              <Check className="mt-1 h-4 w-4 shrink-0 text-accent" />
              {b}
            </li>
          ))}
        </ul>
      </div>
    </Layout>
  );
}
